<template>
  <div class="desc_cargo">
    <!--Stats cards-->
    <h4 class="title">Quais são suas atividades? </h4>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <stats-card>
          <div class="icon-big icon-info text-center" slot="header">
            <i class="ti-user"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ currentUser.position.name }}</p>
          </div>
          <div class="stats footer_cargo" slot="footer">
            <div class="row">
              <div class="col-xs-6 comp">
                <label>Número do Cargo</label><br/>
                {{ currentUser.position.cod }}<br/>
              </div>
              <div class="col-xs-6 comp">
                <label>UNIORG</label><br/>
                {{ currentUser.position.department.company.cod }}<br/>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 comp">
                <label>Descrição do Cargo</label><br/>
                {{ currentUser.position.function_description }}<br/><br/>
              </div>
            </div>
          </div>
        </stats-card>
      </div>
    </div>
  </div>
</template>
<script>
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'

  export default {
    components: {
      StatsCard
    },
    data () {
      return {

      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }

</script>
<style>
.grade_comp{
  text-align:right;
}
.footer_cargo .row{margin-bottom:15px;}

ul li{margin-bottom:10px;}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Evaluation/Position.vue